export function hasPermissionAction(permissions, action) {
  if (!action || !Array.isArray(permissions) || permissions.length === 0) {
    return false;
  }

  const tokens = String(action)
    .split("||")
    .map((token) => String(token).trim().toUpperCase())
    .filter(Boolean);

  if (!tokens.length) return false;

  return tokens.some((token) =>
    permissions.some((permission) => String(permission).toUpperCase() === token)
  );
}

export function canViewOrganizationPage(permissions) {
  return hasPermissionAction(permissions, "ORGANIZATION_ALL");
}

export function canSwitchOrganization(permissions) {
  return hasPermissionAction(permissions, "Switch_Organization");
}

export function canAccessOrganizationList(permissions) {
  return (
    canViewOrganizationPage(permissions) || canSwitchOrganization(permissions)
  );
}
